import { render, staticRenderFns } from "./UserFavoriteList.vue?vue&type=template&id=7f5c3710"
import script from "./UserFavoriteList.vue?vue&type=script&lang=js"
export * from "./UserFavoriteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports